import React from 'react';
import ReactDOM from 'react-dom/client';
import { ArrowsPage } from './ArrowsPage';
import { SafeBoundary } from '@/components/SafeBoundary';
import { initMonitoring } from '@/lib/monitoring';
import '../../index.css';
import './profiles.css';

initMonitoring('arrows');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SafeBoundary section="My Arrows">
      <ArrowsPage />
    </SafeBoundary>
  </React.StrictMode>
);
